<div class="px-5 pt-5" *transloco="let t">
    <h1 class="!text-[#0139c5] pb-5 font-bold">Scegli le tue preferenze</h1>
    <div class="flex gap-5 items-center h-[33.5px] mb-5"> <div class="h-fit font-bold !text-[#0139c5] text-[18px]">Invio email attivo</div> <std-checkbox borderTrue="#719CFF" backGroundTrue="#445E99" width="33.5px" height="33.5px" [isChecked]="active" (onChange)="active = $event.checked"></std-checkbox></div>
    <div class="mb-5 flex gap-2.5 flex-wrap max-w-[100%] mx-auto">
       
        @for (filter of filters(); track $index) {
        @if(filter.name != 'status'){<div class="w-full md:w-[300px] relative">
            <std-select customClassContaier="custom-select"
            [currentValue]="savedFilters[filter.name]"
                customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                [filterable]="true" (onChangeValue)="newFiltersToApply = true;changeFilters($event,filter.name)"
                [showMultipleSelection]="false" [multiple]="true" [placeholder]="filter.name == 'regioni' ? 'Regioni ammissibili' : t(filter.name)" [data]="filter.labels"
                bindLabel="name" bindValue="id" [closeOnSelection]="false"></std-select>
        </div>}}
        <div class="flex gap-10">

        </div>
    </div>
    <std-button (click)="savePreference()" id="button-login" size="sm"
                buttonClass="bg-quaternary mb-2.5 cursor-pointer rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">{{isSubscribed ? 'Salva' : 'Iscriviti'}}</std-button>
</div>